import { lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import PrivateRoute from 'src/PrivateRoute';
import NotFound from 'src/Layouts/NotFound';

import LoginView from 'src/Containers/LoginView';
import {
  SomethingsView,
  SomethingView,
  SomethingEditView,
} from 'src/Containers/SomethingViews';
import {
  AnythingsView,
  AnythingView,
  AnythingEditView,
} from 'src/Containers/AnythingViews';
import SearchView from 'src/Containers/SearchView';
import TagsView from 'src/Containers/TagsView';
import UserProfile from 'src/Containers/UserProfile';

import TagDetails from 'src/Components/Tag/TagDetails';
import TagEdit from 'src/Components/Tag/TagEdit';

// Code splitting: https://reactjs.org/docs/code-splitting.html#route-based-code-splitting
const DeferredMapView = lazy(() => import('src/Containers/MapView'));
const DeferredDesignGuide = lazy(() => import('src/Containers/DesignGuide'));

function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateRoute />}>
          <Route index element={<SomethingsView />} />
        </Route>

        {/* Somethings */}
        <Route path="somethings" element={<PrivateRoute />}>
          <Route path=":id" element={<SomethingView />} />
          <Route path=":id/edit" element={<SomethingEditView />} />
          <Route index element={<SomethingsView />} />
        </Route>

        {/* Anythings */}
        <Route path="anythings" element={<PrivateRoute />}>
          <Route path=":id" element={<AnythingView />} />
          <Route path=":id/edit" element={<AnythingEditView />} />
          <Route index element={<AnythingsView />} />
        </Route>

        {/* Tags */}
        <Route path="tags" element={<PrivateRoute />}>
          <Route path=":id" element={<TagDetails />} />
          <Route path=":id/edit" element={<TagEdit />} />
          <Route index element={<TagsView />} />
        </Route>

        {/* User */}
        <Route path="user" element={<PrivateRoute />}>
          <Route path="profile" element={<UserProfile />} />
        </Route>

        {/* Map view */}
        <Route path="map" element={<PrivateRoute fullscreen />}>
          <Route index element={<DeferredMapView />} />
        </Route>

        {/* Search result */}
        <Route path="search" element={<PrivateRoute />}>
          <Route index element={<SearchView />} />
        </Route>

        {/* Design */}
        <Route path="/design" element={<DeferredDesignGuide />} />

        {/* Auth */}
        <Route path="/login" element={<LoginView />} />

        {/* 404 */}
        <Route element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
